import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SimulationComponent } from './simulation.component';
import { LiveModule } from './live/live.module';
import { AdvancedModule } from './advanced/advanced.module';
import { InvestModule } from './invest/invest.module';
import { DerogationModule } from './derogation/derogation.module';

@NgModule({
  declarations: [
      SimulationComponent
  ],
  imports: [
    CommonModule,
    LiveModule,
    AdvancedModule,
    InvestModule,
    DerogationModule,
    RouterModule
  ]
})
export class SimulationModule { }
